import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import ReflectionPromptsScreen from '../screen'
import ReflectionPromptRoutes from '../../reflection-prompt/routes'

const ReflectionPrompsRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.REFLECTION_PROMPTS} component={ReflectionPromptsScreen} />
            <ReflectionPromptRoutes />
        </React.Fragment>
    )
}

export default ReflectionPrompsRoutes